var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{attrs:{"id":"loading"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balls"},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }